"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";

// 연습 모드에서 정답 공개 후 자동으로 다음 문제로 넘어갈지 여부. URL의 auto=1
// 쿼리 파라미터로 상태를 들고 다니므로, 문제를 넘어가도(전체 페이지 리렌더) 설정이 유지된다.
export function AutoAdvanceToggle() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const enabled = searchParams.get("auto") === "1";

  function toggle() {
    const params = new URLSearchParams(searchParams.toString());
    if (enabled) params.delete("auto");
    else params.set("auto", "1");
    const query = params.toString();
    router.replace(query ? `${pathname}?${query}` : pathname);
  }

  return (
    <label className="flex w-fit cursor-pointer items-center gap-2 text-xs text-foreground/60">
      <input
        type="checkbox"
        checked={enabled}
        onChange={toggle}
        className="accent-foreground"
      />
      자동 넘어가기 (정답 확인 후 3초 뒤 다음 문제)
    </label>
  );
}
